import { render, staticRenderFns } from "./FormDownload.vue?vue&type=template&id=2c476f5e&scoped=true"
import script from "./FormDownload.vue?vue&type=script&lang=ts"
export * from "./FormDownload.vue?vue&type=script&lang=ts"
import style0 from "./FormDownload.vue?vue&type=style&index=0&id=2c476f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c476f5e",
  null
  
)

export default component.exports